function populateActionTypes<T extends Record<string, Record<string, string>>>(
  actionTypes: T,
) {
  (Object.keys(actionTypes) as Array<keyof T>).forEach(category => {
    const actions: Record<string, string> = actionTypes[category];
    Object.keys(actions).forEach(actionType => {
      actions[actionType] = `${String(category)}.${actionType}`;
    });
  });
  return actionTypes;
}

const ActionType = populateActionTypes({
  User: {
    CHANGE_PASSWORD: "",
    CONFIRM_EMAIL: "",
    LOCATION_TO_TIME_ZONE: "",
    LOGGED_IN: "",
    LOGIN: "",
    REFRESH: "",
    UPDATE: "",
    CURRENT_USER_UPDATED: "",
    REDIRECT_TO_LEARNER_APP: "",
  },

  Payment: {
    CARD_OBTAINED: "",
    CREATE: "",
    APPLE_PAY_AVAILABLE: "",
    APPLE_PAY_SHOWN: "",
    APPLE_PAY_CLICKED: "",
    APPLE_PAY_USED: "",
    CARD_CONFIRMED: "",
    CARD_CONFIRMATION_ATTEMPT: "",
  },

  Webapp: {
    CHECK_INTERCOM: "",
    SET_TOP_NOTICE: "",
  },
});

export default ActionType;
